import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAllTicket } from "../../service/endpoints";

export const getTickethandler = createAsyncThunk('getTickethandler', async (data) => {
  try {
    const response = await getAllTicket(data);
    console.log(response, '=================');
    return response.data.response;

  } catch (error) {
    console.log(error, 'Error');
    if (error.response !== undefined) {
      console.log('fail', error);
      throw error.response;
    } else
    {
      console.log(error);
      throw error.response;
    }
  }
});


const getTicketSlice = createSlice({
  name: 'getTicket',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: (builder) => {
    builder.addCase(getTickethandler.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(getTickethandler.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getTickethandler.rejected, (state, action) => {
      console.log(action.state);
      state.isError = true;
      console.log(action.payload);

    });
  }

});

export default getTicketSlice.reducer;